export default __webpack_public_path__ + "static/B36-102fba5590218d80cf2fca191accbca7.png";